import { FilterIcon } from 'lucide-react';
import * as React from 'react';
import { getTranslate } from 'react-localize-redux';
import styled from 'styled-components';
import storeLang from '../../helpers/storeLang';
import CloseIcon from '../../styles/custom-icons/close';
import { DefaultButton } from '../../styles/global/css/GlobalButton';
import { GreySidely, PastelPrimaryColor, PrimaryColor } from '../../styles/global/css/Utils';
import { Text } from './style/Style';

const NoWrapText = styled(Text) <{ color?: string }>`
	white-space:nowrap;
	color: ${props => props.color ?? PrimaryColor};
`;

function ToolbarFilterButton(props: {
	activeFilters?: number
	onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
	onDeleteFilter?: () => void,
	title?: string,
	activeTitle?: string,
	icon?: JSX.Element,
	isActive?: boolean,
	color?: string
}): JSX.Element {
	const translate = getTranslate(storeLang.getState().localize);

	return <ToolBarButton active={props.isActive || (props.activeFilters !== undefined && props.activeFilters > 0)} onClick={props.onClick} onDelete={props.onDeleteFilter}>
		<div style={{ marginRight: '5px' }}>{props.icon ?? <FilterIcon color={props.color ?? PrimaryColor} />}</div>
		<NoWrapText color={props.color}>{props.activeFilters !== undefined && props.activeFilters > 0 ? (props.activeTitle ?? translate('global.filter.active_filter').toString()).replace('{{NUMBER}}', props.activeFilters.toString()) : (props.title ?? translate('global.filter.advanced_filter').toString())}</NoWrapText>
	</ToolBarButton>;
}


export function ToolBarButton(props: { active?: boolean, children?: React.ReactNode, onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void, onDelete?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void }) {
	return <ToolBarButtonWrapper>
		<ToolBarButtonDiv onClick={props.onClick} active={props.active}>
			{props.children}
			{props.active && props.onDelete &&
				<CloseWrapper onClick={props.onDelete}>
					<CloseIcon size={24} />
				</CloseWrapper>
			}
		</ToolBarButtonDiv>
	</ToolBarButtonWrapper>;
}

const ToolBarButtonWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 5px;
`;

const ToolBarButtonDiv = styled(DefaultButton) <{ active?: boolean }>`
	transition: 0s;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 3px;
	font-size: 13px;
	background-color: ${props => props.active ? PastelPrimaryColor : 'transparent'};
	padding: 0 10px;
	color: ${PrimaryColor};
	margin: 0;
	${p => p.active ? '' : `&:hover {
        background-color: color-mix(in oklab, ${PastelPrimaryColor} 50%, transparent);
    }`}
    text-wrap: nowrap;

    /* cancel DefaultButton brightness on hover */
      &:hover:enabled {
          filter: brightness(1);
      }
`;

const CloseWrapper = styled.button`
	border: none;
	background: none;
	padding: 0;
	margin-right: -5px;

	& > svg {
		color: ${GreySidely};
	}
	&:hover {
		& > svg {
			color: unset;
		}
	}
`;

export default ToolbarFilterButton;
